// src/pages/AttendanceEntry/attendanceEntryThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAttendanceEmployeeApi,
  saveAllAttendanceApi,
  saveAttendanceApi,
} from "../../apiservice/hrpayroll";
import { getLocationApi, getUserApi } from "../../apiservice/setting";

// 🔹 Fetch attendance records
export const fetchAttendance = createAsyncThunk(
  "attendance/fetchAttendance",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getAttendanceEmployeeApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Internal Error");
    }
  }
);

// 🔹 Save all attendance (bulk)
export const saveAllAttendance = createAsyncThunk(
  "attendance/saveAllAttendance",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await saveAllAttendanceApi(payload);
      const { filters } = getState().attendance;
      dispatch(
        fetchAttendance({
          employeeId: filters?.employee_id || null,
          year: filters?.year,
          month: filters?.month,
          attendanceDate: filters.attendanceDate,
          selectedFilterType: "All",
          typeId: filters.typeId || null,
        })
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Internal Error");
    }
  }
);

// 🔹 Save attendance (single employee)
export const saveAttendance = createAsyncThunk(
  "attendance/saveAttendance",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await saveAttendanceApi(payload);
      const { filters } = getState().attendance;
      dispatch(
        fetchAttendance({
          employeeId: filters?.employee_id || null,
          year: filters?.year,
          month: filters?.month,
          attendanceDate: filters.attendanceDate,
          selectedFilterType: "All",
          typeId: filters.typeId || null,
        })
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Internal Error");
    }
  }
);

// 🔹 Fetch users
export const fetchUsers = createAsyncThunk(
  "attendance/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getUserApi({ "select-type": "active" });
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Internal Error");
    }
  }
);

// 🔹 Fetch locations
export const fetchLocations = createAsyncThunk(
  "attendance/fetchLocations",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getLocationApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Internal Error");
    }
  }
);
